import React, { Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Skeletons } from 'ui/components/skeleton';
import { Manifest } from 'services/action';

import {
  SectionSummary,
  SectionInfo,
  SectionLegs,
} from '../../component/detail';
import _ from 'underscore';

const Map = React.lazy(() => import('ui/components/mapbox/map.monitoring'));

const ManifestDetail = ({ data }) => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Manifest.Show']
  );

  const [loading, setLoading] = React.useState(true);
  const [manifest, setManifest] = React.useState(true);
  const [privilege, setPrivilege] = React.useState(null);

  const $onLoad = async () => {
    const req = await Dispatch(Manifest.$show(data?.id));

    if (req?.message === 'success') {
      setManifest(req?.data);
    } else {
    }
  };

  const $getPrivilege = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.manifest',
    });
    setPrivilege(x);
  };

  React.useEffect(() => {
    if (!data) return;

    $onLoad();

    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, [data]);

  React.useEffect(() => {
    $getPrivilege();
  }, [Session]);

  return (
    <div className="body-container bg-light border-top">
      <div>
        {loading ? (
          <Skeletons height="570px" />
        ) : (
          <div className="position-relative">
            <Suspense fallback={<div>Loading...</div>}>
              <Map manifest={manifest} />
            </Suspense>
          </div>
        )}
      </div>

      <div className="p3">
        <SectionSummary manifest={manifest} />
        <div className="row">
          <div className="col-md-4">
            <SectionInfo manifest={manifest} loading={StateLoading} />
          </div>
          <div className="col-md-8">
            <SectionLegs
              manifest={manifest}
              onLegChanges={$onLoad}
              loading={StateLoading}
              privilege={!Session?.privileges || privilege?.action === 'manage'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManifestDetail;
